import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import AddMonitorBar from './AddMonitorBar';
import WatchlistStarterCards from './WatchlistStarterCards';
import { TRANSLATION_KEY } from '../constants';
import css from './WatchlistEmptyState.css';

const WatchlistEmptyState = ({
    prompt,
    onPromptChange,
    onSubmit,
    scheduleCron,
    onScheduleClick,
    onOpenEditor,
    onPickSuggestion,
    submitting = false,
    error = null,
}) => (
    <div className={css.emptyState}>
        <div className={css.title}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.TITLE`} />
        </div>
        <div className={css.subtitle}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUBTITLE`} />
        </div>
        <AddMonitorBar
            prompt={prompt}
            onPromptChange={onPromptChange}
            onSubmit={onSubmit}
            scheduleCron={scheduleCron}
            onScheduleClick={onScheduleClick}
            onOpenEditor={onOpenEditor}
            submitting={submitting}
            error={error}
            isEmptyVariant
        />
        <div className={css.suggestionsTitle}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUGGESTIONS_TITLE`} />
        </div>
        <WatchlistStarterCards onPick={onPickSuggestion} />
    </div>
);

WatchlistEmptyState.propTypes = {
    prompt: PropTypes.string.isRequired,
    onPromptChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    scheduleCron: PropTypes.string.isRequired,
    onScheduleClick: PropTypes.func.isRequired,
    onOpenEditor: PropTypes.func.isRequired,
    onPickSuggestion: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
};

export default WatchlistEmptyState;
